// import React from "react";

// const Section8 = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Sarah Johnson",
//       role: "Marketing Director",
//       quote:
//         "Working with this team has transformed our brand identity. Their attention to detail and creative approach exceeded our expectations.",
//       rating: 5,
//     },
//     {
//       id: 2,
//       name: "David Chen",
//       role: "Startup Founder",
//       quote:
//         "The process was seamless from start to finish. They truly understand how to bring visions to life while keeping everything professional and organized.",
//       rating: 5,
//     },
//     {
//       id: 3,
//       name: "Emma Williams",
//       role: "Creative Director",
//       quote:
//         "Their strategic thinking and design expertise helped us achieve remarkable results. Highly recommended for any business looking to elevate their brand.",
//       rating: 5,
//     },
//   ];

//   const renderStars = (rating) => {
//     return [...Array(rating)].map((_, index) => (
//       <span key={index} className="text-black">
//         ★
//       </span>
//     ));
//   };

//   return (
//     <section className="py-10 bg-[#F2EFEA]">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2
//           className="text-3xl text-center mb-12 tracking-wider"
//           style={{
//             fontFamily: "Blacker Pro Display",
//           }}
//         >
//           WHAT OUR CLIENTS SAY
//         </h2>

//         <div className="grid md:grid-cols-3 gap-8">
//           {testimonials.map((testimonial) => (
//             <div
//               key={testimonial.id}
//               className="flex flex-col p-6 rounded-lg shadow-sm"
//               style={{ backgroundColor: "#FFFFFF" }}
//             >
//               <div className="flex mb-4 text-lg">
//                 {renderStars(testimonial.rating)}
//               </div>

//               <blockquote className="flex-grow">
//                 <p className="text-black italic mb-6 leading-relaxed">
//                   "{testimonial.quote}"
//                 </p>
//               </blockquote>

//               <div className="mt-auto">
//                 <p className="font-medium text-black">{testimonial.name}</p>
//                 <p className="text-sm" style={{ color: "#666" }}>
//                   {testimonial.role}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section8;
// import React, { useState } from "react";

// const Section8 = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Omar Khan",
//       role: "Nyia Hotel",
//       quote:
//         "CEG has completely transformed Nyia Hotel's online presence! Their expertise in social media management has given us an incredibly aesthetic feed that perfectly showcasesour hotel's charm. We've seen a noticeable increase in followers and engagement, attracting more guests than ever before. Their creativity, professionalism, and understanding of our vision have made all the difference. Highly recommend CEG for taking social media to the next level!",
//       rating: 5,
//     },
//     {
//       id: 2,
//       name: "Tazeen",
//       role: "Tazeen’s Dental Care",
//       quote:
//         "I just wanted to express how wonderful this collaboration has been. The work you have done to transform my Instagram feed into something truly stunning is beyond impressive. Your eye for detail is remarkable, and I’m so grateful to have connected with you. Thank you for everything!",
//       rating: 5,
//     },
//     {
//       id: 3,
//       name: "Shariq",
//       role: "Shariq and associates",
//       quote:
//         "Working with CEG has been a game-changer for Shariq Dental & Associates! Their expertise in managing our social media, especially Instagram, has been outstanding. They’ve helped us connect with our patients better, manage reviews seamlessly, and create a stunning feed that truly represents our clinic's vibe. Highly recommend them for anyone looking to grow their online presence!",
//       rating: 5,
//     },
//     {
//       id: 4,
//       name: "Mahnoor Akbar",
//       role: "sial dental care",
//       quote:
//         "Since partnering with CEG, our clinic's social media strategy has been a huge success. They’ve provided expert management of our platforms, including engaging posts, regular updates, and targeted SEO, which has helped us reach more potential patients. CEG makes digital marketing easy and effective, saving us time while delivering real results. If you want to grow your business online, CEG is the team to trust!",
//       rating: 5,
//     },
//   ];

//   const [startIndex, setStartIndex] = useState(0);

//   const renderStars = (rating) => {
//     return [...Array(rating)].map((_, index) => (
//       <span key={index} className="text-black">
//         ★
//       </span>
//     ));
//   };

//   const handleNext = () => {
//     setStartIndex((prevIndex) =>
//       prevIndex + 1 >= testimonials.length ? 0 : prevIndex + 1
//     );
//   };

//   const handlePrevious = () => {
//     setStartIndex((prevIndex) =>
//       prevIndex - 1 < 0 ? testimonials.length - 1 : prevIndex - 1
//     );
//   };

//   const visibleTestimonials =
//     testimonials.slice(startIndex, startIndex + 3).length === 3
//       ? testimonials.slice(startIndex, startIndex + 3)
//       : [
//           ...testimonials.slice(startIndex),
//           ...testimonials.slice(0, 3 - (testimonials.length - startIndex)),
//         ];

//   return (
//     <section className="py-10 bg-[#F2EFEA] relative mt-40 lg:mt-0 sm:mt-0 md:mt-0">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2
//           className="text-3xl text-center mb-12 tracking-wider"
//           style={{
//             fontFamily: "Blacker Pro Display",
//           }}
//         >
//           WHAT OUR CLIENTS SAY
//         </h2>

//         <div className="flex items-center">
//           <button
//             onClick={handlePrevious}
//             className="text-black bg-white rounded-full shadow p-2"
//             aria-label="Previous"
//           >
//             &#8249;
//           </button>

//           <div className="grid md:grid-cols-3 gap-8 flex-grow mx-4">
//             {visibleTestimonials.map((testimonial) => (
//               <div
//                 key={testimonial.id}
//                 className="flex flex-col p-6 rounded-lg shadow-sm"
//                 style={{ backgroundColor: "#FFFFFF" }}
//               >
//                 <div className="flex mb-4 text-lg">
//                   {renderStars(testimonial.rating)}
//                 </div>

//                 <blockquote className="flex-grow">
//                   <p className="text-black italic mb-6 leading-relaxed">
//                     "{testimonial.quote}"
//                   </p>
//                 </blockquote>

//                 <div className="mt-auto">
//                   <p className="font-medium text-black">{testimonial.name}</p>
//                   <p className="text-sm" style={{ color: "#666" }}>
//                     {testimonial.role}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={handleNext}
//             className="text-black bg-white rounded-full shadow p-2"
//             aria-label="Next"
//           >
//             &#8250;
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section8;
// import React, { useState } from "react";
// import pic from "../../Assets/Hero-image.jpg";

// const testimonials = [
//   {
//     id: 1,
//     content:
//       "I THOROUGHLY ENJOYED THE ENTIRE PROCESS AND WOULDN'T CHANGE MUCH ABOUT MY EXPERIENCE! THE ONBOARDING WAS EFFICIENT AND THE TEAM'S COMMUNICATION WAS OUTSTANDING. I LOVED OUR MEETING, AND THE EDITING PERFECTLY MATCHED MY AESTHETIC. I RECEIVED THE PHOTOS QUICKLY AND ABSOLUTELY LOVED THEM- I'LL HAVE CONTENT FOR YEARS! THANK YOU, THANK YOU, THANK YOU! IT WAS A BLESSING WORKING WITH YOU ALL AND I'M SO EXCITED TO USE ALL MY CONTENT!",
//     author: "Cora Bernhardt",
//   },
//   {
//     id: 2,
//     content:
//       "THE TEAM'S DEDICATION TO EXCELLENCE IS EVIDENT IN EVERY ASPECT OF THEIR WORK. FROM THE INITIAL CONSULTATION TO THE FINAL DELIVERY, THE EXPERIENCE WAS NOTHING SHORT OF EXCEPTIONAL. THE ATTENTION TO DETAIL AND CREATIVE VISION PERFECTLY CAPTURED OUR BRAND'S ESSENCE.",
//     author: "James Mitchell",
//   },
// ];

// const Section8 = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [nextSlide, setNextSlide] = useState(null);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [slideDirection, setSlideDirection] = useState(null);

//   const handleNext = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setSlideDirection("right");
//     const next = (currentSlide + 1) % testimonials.length;
//     setNextSlide(next);

//     setTimeout(() => {
//       setCurrentSlide(next);
//       setNextSlide(null);
//       setSlideDirection(null);
//       setIsAnimating(false);
//     }, 500);
//   };

//   const handlePrev = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setSlideDirection("left");
//     const next = (currentSlide - 1 + testimonials.length) % testimonials.length;
//     setNextSlide(next);

//     setTimeout(() => {
//       setCurrentSlide(next);
//       setNextSlide(null);
//       setSlideDirection(null);
//       setIsAnimating(false);
//     }, 500);
//   };

//   return (
//     <div className="relative w-full h-[600px]">
//       {/* Background Image */}
//       <div
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat brightness-50"
//         style={{ backgroundImage: `url(${pic})` }}
//       />

//       {/* Left Arrow */}
//       <button
//         onClick={handlePrev}
//         className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-gray-300 transition-colors z-10"
//         disabled={isAnimating}
//       >
//         <svg
//           viewBox="0 0 24 24"
//           className="w-8 h-8"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1"
//         >
//           <path d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>

//       {/* Content */}
//       <div className="relative z-0 h-full overflow-hidden flex items-center justify-center">
//         <div className="w-full max-w-4xl px-6 mx-auto text-center">
//           <style>
//             {`
//           @keyframes slideOutLeft {
//             from { transform: translateX(0); }
//             to { transform: translateX(-100%); }
//           }
//           @keyframes slideOutRight {
//             from { transform: translateX(0); }
//             to { transform: translateX(100%); }
//           }
//           @keyframes slideInLeft {
//             from { transform: translateX(-100%); }
//             to { transform: translateX(0); }
//           }
//           @keyframes slideInRight {
//             from { transform: translateX(100%); }
//             to { transform: translateX(0); }
//           }
//           .slide-out-left {
//             animation: slideOutLeft 0.5s ease-in-out forwards;
//           }
//           .slide-out-right {
//             animation: slideOutRight 0.5s ease-in-out forwards;
//           }
//           .slide-in-left {
//             animation: slideInLeft 0.5s ease-in-out forwards;
//           }
//           .slide-in-right {
//             animation: slideInRight 0.5s ease-in-out forwards;
//           }
//         `}
//           </style>

//           {/* Current Slide */}
//           <div
//             className={`absolute lg:w-[900px] w-full lg:-mt-12 ${
//               slideDirection === "right"
//                 ? "slide-out-left"
//                 : slideDirection === "left"
//                 ? "slide-out-right"
//                 : ""
//             }`}
//           >
//             <p className="text-white text-lg md:text-xl text-center items-center tracking-wide leading-relaxed mb-8">
//               {testimonials[currentSlide].content}
//             </p>
//             <p className="text-white text-sm md:text-base">
//               - {testimonials[currentSlide].author}
//             </p>
//           </div>

//           {/* Next Slide */}
//           {nextSlide !== null && (
//             <div
//               className={`absolute w-full ${
//                 slideDirection === "right" ? "slide-in-right" : "slide-in-left"
//               }`}
//             >
//               <p className="text-white text-lg md:text-xl tracking-wide leading-relaxed mb-8">
//                 {testimonials[nextSlide].content}
//               </p>
//               <p className="text-white text-sm md:text-base">
//                 - {testimonials[nextSlide].author}
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Right Arrow */}
//       <button
//         onClick={handleNext}
//         className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-gray-300 transition-colors z-10"
//         disabled={isAnimating}
//       >
//         <svg
//           viewBox="0 0 24 24"
//           className="w-8 h-8"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1"
//         >
//           <path d="M9 5l7 7-7 7" />
//         </svg>
//       </button>
//     </div>
//   );
// };

// export default Section8;

// import React, { useState } from "react";
// import pic from "../../Assets/Hero-image.jpg";

// const testimonials = [
//   {
//     id: 1,
//     content:
//       "I THOROUGHLY ENJOYED THE ENTIRE PROCESS AND WOULDN'T CHANGE MUCH ABOUT MY EXPERIENCE! THE ONBOARDING WAS EFFICIENT AND THE TEAM'S COMMUNICATION WAS OUTSTANDING. I LOVED OUR MEETING, AND THE EDITING PERFECTLY MATCHED MY AESTHETIC. I RECEIVED THE PHOTOS QUICKLY AND ABSOLUTELY LOVED THEM- I'LL HAVE CONTENT FOR YEARS! THANK YOU, THANK YOU, THANK YOU! IT WAS A BLESSING WORKING WITH YOU ALL AND I'M SO EXCITED TO USE ALL MY CONTENT!",
//     author: "Cora Bernhardt",
//   },
//   {
//     id: 2,
//     content:
//       "THE TEAM'S DEDICATION TO EXCELLENCE IS EVIDENT IN EVERY ASPECT OF THEIR WORK. FROM THE INITIAL CONSULTATION TO THE FINAL DELIVERY, THE EXPERIENCE WAS NOTHING SHORT OF EXCEPTIONAL. THE ATTENTION TO DETAIL AND CREATIVE VISION PERFECTLY CAPTURED OUR BRAND'S ESSENCE.",
//     author: "James Mitchell",
//   },
// ];

// const Section8 = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [nextSlide, setNextSlide] = useState(null);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [slideDirection, setSlideDirection] = useState(null);

//   const handleNext = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setSlideDirection("right");
//     const next = (currentSlide + 1) % testimonials.length;
//     setNextSlide(next);

//     setTimeout(() => {
//       setCurrentSlide(next);
//       setNextSlide(null);
//       setSlideDirection(null);
//       setIsAnimating(false);
//     }, 500);
//   };

//   const handlePrev = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setSlideDirection("left");
//     const next = (currentSlide - 1 + testimonials.length) % testimonials.length;
//     setNextSlide(next);

//     setTimeout(() => {
//       setCurrentSlide(next);
//       setNextSlide(null);
//       setSlideDirection(null);
//       setIsAnimating(false);
//     }, 500);
//   };

//   return (
//     <div className="relative w-full h-[600px] sm:h-[500px] xs:h-[400px]">
//       {/* Background Image */}
//       <div
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat brightness-50"
//         style={{ backgroundImage: `url(${pic})` }}
//       />

//       {/* Left Arrow */}
//       <button
//         onClick={handlePrev}
//         className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-8 sm:h-8 flex items-center justify-center text-white hover:text-gray-300 transition-colors z-10"
//         disabled={isAnimating}
//       >
//         <svg
//           viewBox="0 0 24 24"
//           className="w-6 h-6 sm:w-5 sm:h-5"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1"
//         >
//           <path d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>

//       {/* Content */}
//       <div className="relative z-0 h-full overflow-hidden flex items-center justify-center">
//         <div className="w-full max-w-4xl px-4 sm:px-6 xs:px-2 mx-auto text-center">
//           <style>
//             {`
//           @keyframes slideOutLeft {
//             from { transform: translateX(0); }
//             to { transform: translateX(-100%); }
//           }
//           @keyframes slideOutRight {
//             from { transform: translateX(0); }
//             to { transform: translateX(100%); }
//           }
//           @keyframes slideInLeft {
//             from { transform: translateX(-100%); }
//             to { transform: translateX(0); }
//           }
//           @keyframes slideInRight {
//             from { transform: translateX(100%); }
//             to { transform: translateX(0); }
//           }
//           .slide-out-left {
//             animation: slideOutLeft 0.5s ease-in-out forwards;
//           }
//           .slide-out-right {
//             animation: slideOutRight 0.5s ease-in-out forwards;
//           }
//           .slide-in-left {
//             animation: slideInLeft 0.5s ease-in-out forwards;
//           }
//           .slide-in-right {
//             animation: slideInRight 0.5s ease-in-out forwards;
//           }
//         `}
//           </style>

//           {/* Current Slide */}
//           <div
//             className={`absolute lg:w-[900px] sm:w-[200px] ${
//               slideDirection === "right"
//                 ? "slide-out-left"
//                 : slideDirection === "left"
//                 ? "slide-out-right"
//                 : ""
//             }`}
//           >
//             <p className="text-white text-lg sm:text-base xs:text-sm tracking-wide leading-relaxed mb-8">
//               {testimonials[currentSlide].content}
//             </p>
//             <p className="text-white text-sm xs:text-xs">
//               - {testimonials[currentSlide].author}
//             </p>
//           </div>

//           {/* Next Slide */}
//           {nextSlide !== null && (
//             <div
//               className={`absolute w-full ${
//                 slideDirection === "right" ? "slide-in-right" : "slide-in-left"
//               }`}
//             >
//               <p className="text-white text-lg sm:text-base xs:text-sm tracking-wide leading-relaxed mb-8">
//                 {testimonials[nextSlide].content}
//               </p>
//               <p className="text-white text-sm xs:text-xs">
//                 - {testimonials[nextSlide].author}
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Right Arrow */}
//       <button
//         onClick={handleNext}
//         className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-8 sm:h-8 flex items-center justify-center text-white hover:text-gray-300 transition-colors z-10"
//         disabled={isAnimating}
//       >
//         <svg
//           viewBox="0 0 24 24"
//           className="w-6 h-6 sm:w-5 sm:h-5"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1"
//         >
//           <path d="M9 5l7 7-7 7" />
//         </svg>
//       </button>
//     </div>
//   );
// };

// export default Section8;

import React, { useState } from "react";
import { ChevronLeft, ChevronRight, EarthLock, Quote } from "lucide-react";
import gsap from "gsap";
import pic from "../../Assets/Hero-image.jpg";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      content:
        "CEG has completely transformed Nyia Hotel's online presence! Their expertise in social media management has given us an incredibly aesthetic feed that perfectly showcases our hotel's charm. We've seen a noticeable increase in followers and engagement, attracting more guests than ever before. Their creativity, professionalism, and understanding of our vision have made all the difference. Highly recommend CEG for taking social media to the next level!",
      author: "Omar Khan (Nyia Hotel)",
    },
    {
      id: 2,
      content:
        "I just wanted to express how wonderful this collaboration has been. The work you have done to transform my Instagram feed into something truly stunning is beyond impressive. Your eye for detail is remarkable, and I’m so grateful to have connected with you. Thank you for everything!",
      author: "Tazeen (Tazeen’s Dental Care)",
    },
    {
      id: 3,
      content:
        "Working with CEG has been a game-changer for Shariq Dental & Associates! Their expertise in managing our social media, especially Instagram, has been outstanding. They’ve helped us connect with our patients better, manage reviews seamlessly, and create a stunning feed that truly represents our clinic's vibe. Highly recommend them for anyone looking to grow their online presence!",
      author: "Shariq (Shariq and associates)",
    },
    {
      id: 4,
      content:
        "Since partnering with CEG, our clinic's social media strategy has been a huge success. They’ve provided expert management of our platforms, including engaging posts, regular updates, and targeted SEO, which has helped us reach more potential patients. CEG makes digital marketing easy and effective, saving us time while delivering real results. If you want to grow your business online, CEG is the team to trust!",
      author: "Mahnoor Akbar (sial dental care)",
    },
  ];

  const handleNext = () => {
    gsap.fromTo(
      ".testimonial-content",
      { x: "100%", opacity: 0 },
      { x: "0%", opacity: 1, duration: 0.8, ease: "power3.out" }
    );
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrev = () => {
    gsap.fromTo(
      ".testimonial-content",
      { x: "-100%", opacity: 0 },
      { x: "0%", opacity: 1, duration: 0.8, ease: "power3.out" }
    );
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="relative flex items-center justify-center h-[600px] w-full mt-72 lg:mt-0 sm:mt-72">
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
        style={{ backgroundImage: `url(${pic})` }}
      ></div>

      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50"></div>

      <div className="z-10 mx-auto px-4 max-w-4xl">
        <div className="relative">
          <Quote className="absolute -top-8 -left-8 w-16 h-16 text-white/10" />
          <div className="testimonial-content space-y-6">
            <p className="text-white text-center text-lg md:text-2xl font-light leading-relaxed italic">
              {testimonials[currentIndex].content}
            </p>
            <div className="flex flex-col items-center space-y-2">
              <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-white/50 to-transparent" />
              <p className="text-white text-sm md:text-lg font-medium flex items-center">
                <EarthLock className="mr-2" />{" "}
                {testimonials[currentIndex].author}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile centered arrows */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-4 md:hidden">
        <button
          onClick={handlePrev}
          className="text-white p-2 bg-gray-700 bg-opacity-50 rounded-full hover:bg-gray-800 transition"
        >
          <ChevronLeft size={24} />
        </button>

        <button
          onClick={handleNext}
          className="text-white p-2 bg-gray-700 bg-opacity-50 rounded-full hover:bg-gray-800 transition"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      {/* Desktop/Tablet arrows on the sides */}
      <button
        onClick={handlePrev}
        className="absolute left-4 md:left-10 text-white p-2 bg-gray-700 bg-opacity-50 rounded-full hover:bg-gray-800 transition hidden md:block"
      >
        <ChevronLeft size={24} />
      </button>

      <button
        onClick={handleNext}
        className="absolute right-4 md:right-10 text-white p-2 bg-gray-700 bg-opacity-50 rounded-full hover:bg-gray-800 transition hidden md:block"
      >
        <ChevronRight size={24} />
      </button>
    </div>
  );
};

export default Testimonials;

// import React, { useState } from "react";
// import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
// import pic from "../../Assets/Hero-image.jpg";
// const Testimonials = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const testimonials = [
//     {
//       id: 1,
//       content:
//         "I thoroughly enjoyed the entire process and wouldn't change much about my experience! The onboarding was efficient and the team's communication was outstanding. I loved our meeting, and the editing perfectly matched my aesthetic. I received the photos quickly and absolutely loved them- I'll have content for years! Thank you, thank you, thank you! It was a blessing working with you all and I'm so excited to use all my content!",
//       author: "Cora Bernhardt",
//     },
//     {
//       id: 2,
//       content:
//         "The team's dedication to excellence is evident in every aspect of their work. From the initial consultation to the final delivery, the experience was nothing short of exceptional. The attention to detail and creative vision perfectly captured our brand's essence.",
//       author: "James Mitchell",
//     },
//   ];

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
//     );
//   };

//   return (
//     <div className="relative flex items-center justify-center min-h-[600px] w-full bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 overflow-hidden">
//       <div className="absolute inset-0 opacity-20">
//         <div
//           className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
//           style={{ backgroundImage: `url(${pic})` }}
//         ></div>
//       </div>

//       <div className="z-10 mx-auto px-4 max-w-4xl">
//         <div className="relative">
//           <Quote className="absolute -top-8 -left-8 w-16 h-16 text-white/10" />
//           <div className="testimonial-content space-y-6">
//             <p className="text-white text-lg md:text-2xl font-light leading-relaxed">
//               {testimonials[currentIndex].content}
//             </p>
//             <div className="flex flex-col items-center space-y-2">
//               <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-white/50 to-transparent" />
//               <p className="text-white text-sm md:text-lg font-medium">
//                 {testimonials[currentIndex].author}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 md:hidden">
//         <button
//           onClick={handlePrev}
//           className="p-2 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-300 group"
//         >
//           <ChevronLeft className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
//         </button>
//         <div className="flex space-x-2">
//           {testimonials.map((_, idx) => (
//             <div
//               key={idx}
//               className={`w-2 h-2 rounded-full transition-all duration-300 ${
//                 idx === currentIndex
//                   ? "bg-white w-6"
//                   : "bg-white/50 hover:bg-white/70"
//               }`}
//               onClick={() => setCurrentIndex(idx)}
//             />
//           ))}
//         </div>
//         <button
//           onClick={handleNext}
//           className="p-2 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-300 group"
//         >
//           <ChevronRight className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
//         </button>
//       </div>

//       <button
//         onClick={handlePrev}
//         className="absolute left-4 md:left-10 hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-300 group"
//       >
//         <ChevronLeft className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
//       </button>
//       <button
//         onClick={handleNext}
//         className="absolute right-4 md:right-10 hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-300 group"
//       >
//         <ChevronRight className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
//       </button>
//     </div>
//   );
// };

// export default Testimonials;
